<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr *ngIf="shop.coverUrl">
          <td style="text-align: center">
            <img width="80" [src]="shop.coverUrl" alt="" />
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              <span *ngIf="shop.mobile">{{ shop.mobile }}</span>
              <span *ngIf="shop.email"> - {{ shop.email }}</span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>PHIẾU TÍNH TIỀN</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Ngày:
              {{ receipt.issueDate | date: "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="receipt.id.length > 6">
          <td style="text-align: center">
            <label>
              {{ "common.code" | translate }}:
              {{ receipt.id.substring(receipt.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr *ngIf="receipt.customerName">
          <td style="text-align: left">
            <label> {{ receipt.customerName }} </label>
          </td>
        </tr>
        <tr *ngIf="receipt.customerMobile">
          <td style="text-align: left">
            <label> {{ receipt.customerMobile }} </label>
          </td>
        </tr>
        <tr *ngIf="receipt.customerAddress">
          <td style="text-align: left">
            {{ receipt.customerAddress }}
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            ></table>
          </td>
        </tr>

        <tr>
          <td><hr /></td>
        </tr>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tbody>
          <tr *ngFor="let item of receipt.receiptDetails; let i = index">
            <td colspan="2" style="text-align: left">
              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                class="table-detail-pos"
              >
                <tr>
                  <td colspan="3" style="text-align: left">
                    <label>
                      {{ item.productName }}
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ item.price | number: 0 }}
                  </td>
                  <td>x{{ item.quantity }}</td>
                  <td style="text-align: right">
                    {{ item.netAmount | number: 0 }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="2"><hr /></td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td style="text-align: left">
              <label> Tổng tiền hàng: </label>
            </td>
            <td style="text-align: right">
              {{ receipt.detailNetAmount | number: 0 }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              <label>
                {{ "common.totalDiscountAmount" | translate }}:<span
                  *ngIf="receipt.discountPercent > 0"
                >
                  {{ receipt.discountPercent | number: 0 }}%
                </span>
              </label>
            </td>
            <td style="text-align: right">
              {{ receipt.totalDiscountAmount | number: 0 }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              <h2>Tổng thanh toán:</h2>
            </td>
            <td style="text-align: right">
              <h2>
                {{ receipt.totalAmount | number: 0 }}
              </h2>
            </td>
          </tr>
          <tr *ngIf="receipt.paymentRefund > 0">
            <td style="text-align: left"><label> Khách đưa: </label></td>
            <td style="text-align: right">
              {{ receipt.paymentAmount | number: 0 }}
            </td>
          </tr>
          <tr *ngIf="receipt.paymentRefund > 0">
            <td style="text-align: left"><label>Tiền thối lại: </label></td>
            <td style="text-align: right">
              {{ receipt.paymentRefund | number: 0 }}
            </td>
          </tr>
        </tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td class="height-1"></td>
        </tr>
        <tr *ngIf="shop.description">
          <td style="text-align: center">
            {{ shop.description }}
          </td>
        </tr>
        <tr>
          <td style="text-align: center">Cảm ơn quý khách<br />Hẹn gặp lại</td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
        <tr>
          <td style="text-align: center">
            <img width="70" src="/assets/images/qr-fb-kasoft.png" alt="" />
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            Wifi: KaSoft - Mật khẩu: <b>kasoft.vn</b>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
